import axios from "axios";
require('dotenv').config()
const apigestao = axios.create({
    baseURL: process.env.VUE_APP_URL_GESTAO
});

export default apigestao;
